"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTrackerContext = exports.removeUndefinedProps = void 0;
/**
 * Remove propriedades undefined de um objeto.
 * @private
 */
function removeUndefinedProps(initialProps) {
    const properties = {
        ...initialProps
    };
    Object.keys(properties).forEach(key => properties[key] === undefined && delete properties[key]);
    return properties;
}
exports.removeUndefinedProps = removeUndefinedProps;
/**
 * Cria um contexto de tracking.
 *
 * Todas as propriedades que existem nesse contexto serão injetadas nos eventos disparados que utilizam esse contexto.
 * @param initialProps - Propriedades que vão inicializar o contexto.
 * @public
 * @example
 * createTrackerContext({ appName: 'warren-website', customer_api_id: '...' })
 */
function createTrackerContext(initialProps = {}) {
    const props = removeUndefinedProps(initialProps);
    const context = { value: { ...props } };
    function setProps(props) {
        context.value = { ...removeUndefinedProps(props) };
    }
    return { context, setProps };
}
exports.createTrackerContext = createTrackerContext;
//# sourceMappingURL=tracker-context.js.map